module.exports = __webpack_public_path__ + "static/media/stareway-truck-packages.9ffda91b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/img/stareway-truck-packages.pdf
// module id = 286
// module chunks = 0